module.exports = __webpack_public_path__ + "static/media/apachecordova.f3f10600.png";